import { underwritingExpressionDefinitionApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const RULE_SCHEMA_ACTION_TYPE = createNamedActions('ruleSchema', {
  GET_RULE_SCHEMA_PARAMS: 'GET_RULE_SCHEMA_PARAMS',
});

export const getRuleSchemaParamsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await underwritingExpressionDefinitionApi.getExpressionDefinition();

  return dispatch({
    type: RULE_SCHEMA_ACTION_TYPE.GET_RULE_SCHEMA_PARAMS,
    payload: data,
  });
});
